export default {

    TipologiaMessaggio: {
        Sistema: -1,
        Utente: 0,
        Operatore: 1,
        toString: function (type) {
            switch (parseInt(type)) {
                case -1: return "Messaggio di sistema";
                case 1: return "Messaggio utente";
                case 2: return "Messaggio operatore";
            }
        }
    },

    StatoPratica: {
        InAttesa: 10,
        InCarico: 20,
        Sospesa: 25,
        Risposta: 30,
        Risposta: 40,
        Chiusa: 50,
        Chiusa: 60,
        toString(stato) {
            switch (stato) {
                case 10: return "In attesa";
                case 20: return "In carico";
                case 25: return "Sospesa";
                case 30: return "Risposta";
                case 40: return "Risposta";
                case 50: return "Chiusa";
                case 60: return "Chiusa";
            }
        }
    },

    Quesiti: {
        Aperti: 0,
        Chiusi: 1,
        Archiviati: 2,
        Ricerca: 3,

        toString(quesito) {
            switch (quesito) {
                case this.Aperti: return "aperti";
                case this.Chiusi: return "chiusi";
                case this.Archiviati: return "archiviati";
                case this.Ricerca: return "ricerca";
            }
        }
    },
    
    Giorni: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
};